<footer class="bg-white text-white ">
    <div class="bg-[var(--dark-teal)] ">
        <div class="w-full md:px-[3.5rem]">
            <div class=" container mx-auto ">

                <div class="flex justify-between ">


                    <div class="flex flex-col flex-1 items-center md:items-start mt-4">

                        <a
                            [href]="this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/biddingforgood.action?lp=footer_logo&cmp=ILC-b4g_run')">
                            <img src="FS_Logo_White.png" class="h-9 w-[144px] mt-[75px]">
                        </a>


                        <div class="block md:hidden  flex-wrap gap-1 text-xs mt-2 mb-5">
                            @for (link of linksLeft; track $index; let last = $last) {
                            <ng-container>
                                <a [href]="link.url" target="_blank" rel="noopener noreferrer"
                                    class="hover:underline  text-white cursor-pointer">
                                    {{ link.label }}
                                </a>
                                <span *ngIf="!last">|</span>
                            </ng-container>
                            }
                        </div>


                        <div class=" items-center space-x-3 hidden md:block">
                            <a href="https://www.facebook.com/biddingforgood">
                                <fa-icon [icon]="icons.faFacebook"
                                    style="color: white; font-size: 24px; margin-right: 10px;"
                                    aria-label="Bidding For Good Facebook icon"></fa-icon>
                            </a>
                            <a href="https://twitter.com/biddingforgood">
                                <fa-icon [icon]="icons.faXTwitter"
                                    style="color: white; font-size: 24px; margin-right: 10px;"
                                    aria-label="Bidding For Good Twitter icon"></fa-icon>
                            </a>
                            <a href="https://www.linkedin.com/company/biddingforgood">
                                <fa-icon [icon]="icons.faLinkedin" style="color: white; font-size: 24px;"
                                    aria-label="Bidding For Good LinkedIn icon"></fa-icon>
                            </a>
                        </div>


                    </div>


                    <ng-container *ngFor="let section of linksSections">
                        <div class=" hidden md:block flex-1 mb-10 mt-24">
                            <p class="text-lg font-bold">{{section.label}}</p>
                            <div class="flex flex-col space-y-1">
                                <ng-container *ngFor="let sub of section.subLinks">
                                    <a [href]="sub.url"
                                        class="text-white/80 hover:underline transition-colors cursor-pointer ">
                                        {{sub.label}}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>


    </div>

    <div class="w-full md:px-[3.5rem]">
        <div class="container mx-auto hidden md:block w-full  py-5 text-[var(--dark-teal)]">
            <div class=" flex flex-wrap justify-between ">

                <img alt="rating" class="" src="Reviews.svg" class="items-center" />

                <div class="flex flex-col md:flex-row items-center gap-8">
                    <img src="logos_0000_Layer-1.svg" class="w-[70px] h-[35px]">
                    <img src="logos_0004_Layer-2.svg" class="w-[70px] h-[35px]">
                    <img src="logos_0003_Layer-3.svg" class="w-[70px] h-[35px]">
                    <img src="logos_0002_Layer-4.svg" class="w-[70px] h-[35px]">
                    <img src="logos_0001_Layer-5.svg" class="w-[70px] h-[35px]">
                </div>
            </div>


            <div class="flex justify-center items-center text-center gap-4 mt-6  text-xs">
                <div>
                    © {{ copyright.year }} {{ copyright.company }} {{ copyright.message }}
                </div>
                <div class="flex flex-wrap justify-center items-center gap-2">
                    @for (link of linksLeft; track $index; let last = $last) {
                    <ng-container>
                        <a [href]="link.url" target="_blank" rel="noopener noreferrer"
                            class="hover:underline text-[var(--dark-teal)]">
                            {{ link.label }}
                        </a>
                        <span *ngIf="!last">|</span>
                    </ng-container>
                    }
                </div>
            </div>


        </div>
    </div>

</footer>